
const digest = '5dc8188eb6c8d8285339b4daf1244b48d8add530536c323995890aaabf79addb';
const classes = {"wrapper":"_wrapper_1avde_1","title":"_title_1avde_6","workplacesWrapper":"_workplacesWrapper_1avde_10","workplace":"_workplace_1avde_10","workplaceInForm":"_workplaceInForm_1avde_33","selectsWrapper":"_selectsWrapper_1avde_43","item":"_item_1avde_49","multiplierButton":"_multiplierButton_1avde_52","button":"_button_1avde_56","rootWorkplace":"_rootWorkplace_1avde_60","code":"_code_1avde_76","removeAllButton":"_removeAllButton_1avde_83"};
const css = `._wrapper_1avde_1 {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
._wrapper_1avde_1 ._title_1avde_6 {
  font-size: 16px;
  font-weight: 600;
}
._wrapper_1avde_1 ._workplacesWrapper_1avde_10 {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
._wrapper_1avde_1 ._workplacesWrapper_1avde_10 ._workplace_1avde_10 {
  background: #e7f5fb;
  border-radius: 15px;
  padding: 16px 24px;
  display: flex;
  flex-direction: row;
  font-weight: 500;
  font-size: 14px;
  gap: 12px;
  border: 1px solid #dee9ff;
  align-items: center;
  justify-content: space-between;
  color: #2f61b2;
}
._wrapper_1avde_1 ._workplacesWrapper_1avde_10 ._workplace_1avde_10 span {
  font-weight: 400;
  color: #000000;
}
._wrapper_1avde_1 ._workplacesWrapper_1avde_10 ._workplaceInForm_1avde_33 {
  background: #f6f6f8;
  border-radius: 15px;
  padding: 16px 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  border: 1px solid #ecedf3;
  margin-bottom: 10px;
}
._wrapper_1avde_1 ._workplacesWrapper_1avde_10 ._workplaceInForm_1avde_33 ._selectsWrapper_1avde_43 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
._wrapper_1avde_1 ._workplacesWrapper_1avde_10 ._workplaceInForm_1avde_33 ._selectsWrapper_1avde_43 ._item_1avde_49 {
  flex: 1;
}
._wrapper_1avde_1 ._workplacesWrapper_1avde_10 ._workplaceInForm_1avde_33 ._selectsWrapper_1avde_43 ._multiplierButton_1avde_52 {
  padding-top: 30px;
  display: inline-block;
}
._wrapper_1avde_1 ._button_1avde_56 {
  width: fit-content;
  margin-top: 15px;
}
._wrapper_1avde_1 ._rootWorkplace_1avde_60 {
  background: #f6f6f8;
  border-radius: 15px;
  padding: 16px 24px;
  display: flex;
  flex-direction: row;
  font-weight: 500;
  font-size: 14px;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
  border: 2px solid #1765d8;
}
._wrapper_1avde_1 hr {
  width: 100%;
}
._wrapper_1avde_1 ._code_1avde_76 {
  font-size: 14px;
  padding: 3px 0;
}
._wrapper_1avde_1 ._code_1avde_76 span {
  font-weight: 500;
}
._wrapper_1avde_1 ._removeAllButton_1avde_83 {
  width: fit-content;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  